import React from 'react';
import PropTypes from 'prop-types';

const ProcessingSpinner = ({ show, size }) => {
  const dimension = size === 'small' ? '14' : '20';

  if (!show) {
    return null;
  }

  return (
    <svg className="button-spinner-svg" width={dimension} height={dimension} stroke="#fff" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25" fill="#fff" />
      <g className="button-spinner">
        <circle cx="12" cy="12" r="9.5" fill="none" strokeWidth="3" />
      </g>
    </svg>
  );
};

ProcessingSpinner.propTypes = {
  show: PropTypes.bool,
  size: PropTypes.string,
};

ProcessingSpinner.defaultProps = {
  show: true,
  size: null,
};

export default ProcessingSpinner;
